(() => {
  class CategorySlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.leftFadeOut = this.querySelector(".js-generic__fade-out__category-slider--left");
      this.rightFadeOut = this.querySelector(".js-generic__fade-out__category-slider--right");

      this.btnLeft = this.querySelector(".js-category-slider--prev");
      this.btnRight = this.querySelector(".js-category-slider--next");
      this.sliderContainer = this.querySelector(".js-category-slider__items");
      this.sliderTitle = this.querySelector(".js-category-slider__title");

      const slider = this.querySelector(".js-category-slider__swiper");
      this.initSwiper(slider.id, this.btnLeft.id, this.btnRight.id, this.leftFadeOut, this.rightFadeOut);
      this.calculateTop();
      window.addEventListener("resize", this.calculateTop);
    }

    calculateTop() {
      const top =
        this.sliderTitle.offsetHeight +
        Number(window.getComputedStyle(this.btnLeft.parentElement, null).getPropertyValue("padding-top").slice(0, -2)) +
        36 +
        this.sliderContainer.offsetHeight / 2;
      this.btnLeft.style.top = `${top}px`;
      this.btnRight.style.top = `${top}px`;
    }

    initSwiper(sliderId, prevId, nextId, leftFadeOut, rightFadeOut) {
      var categorySwiper = new Swiper(`#${sliderId}`, {
        slidesPerView: 1.8,
        spaceBetween: 16,
        freeMode: true,
        breakpoints: {
          475: {
            slidesPerView: 3,
            spaceBetween: 12,
            slidesPerGroup: 3,
            freeMode: false,
          },
          640: {
            slidesPerView: 4,
            spaceBetween: 12,
            slidesPerGroup: 4,
            freeMode: false,
          },
          1024: {
            slidesPerView: 4.8,
            spaceBetween: 24,
            slidesPerGroup: 5,
            freeMode: false,
            navigation: {
              nextEl: `#${nextId}`,
              prevEl: `#${prevId}`,
            },
          },
        },
      });

      categorySwiper.on("progress", function (swiper, progress) {
        if (progress === 0) {
          leftFadeOut.classList.add("opacity-0");
          rightFadeOut.classList.remove("opacity-0");
          return;
        }
        if (progress === 1) {
          rightFadeOut.classList.add("opacity-0");
          leftFadeOut.classList.remove("opacity-0");
          return;
        }
        rightFadeOut.classList.remove("opacity-0");
        leftFadeOut.classList.remove("opacity-0");
      });
    }
  }

  customElements.define("category-slider", CategorySlider);
})();
